import type { ApplicationFlag, FlagSurface } from "~/types/storyblok/storyblok";

/**
 * Checks whether a flag may render on a surface.
 * @param flag - Storyblok flag entry, `undefined` when the flag has none
 * @param surface - Where the flag would render: `plp` or `pdp`
 * @returns `true` when `showOn` is empty or matches `surface`
 */
export const isFlagShownOn = (
	flag: Pick<ApplicationFlag, "showOn"> | undefined,
	surface: FlagSurface
): boolean => !flag?.showOn || flag.showOn === surface;
